import React, { useState, useEffect } from 'react';
import MerlinAnalysis from './MerlinAnalysis';
import CommitReview from './CommitReview';

const IssuePanel = () => {
  const [hasCommits, setHasCommits] = useState(false);
  const [commitCount, setCommitCount] = useState(0);
  const [commitReview, setCommitReview] = useState(null);
  const [viewType, setViewType] = useState('analysis');
  const [context, setContext] = useState(null);
  const [panelHeight, setPanelHeight] = useState(0);

  useEffect(() => {
    const initializeContext = async () => {
      if (window.AP) {
        const ap = window.AP;
        const ctx = await ap.context.getContext();
        setContext(ctx);
      }
    };
    
    initializeContext();
  }, []);

  // Update panel height when content changes
  useEffect(() => {
    if (window.AP) {
      const ap = window.AP;
      const content = document.querySelector('.issue-panel');
      if (content) {
        const height = content.offsetHeight;
        ap.resize(height);
        setPanelHeight(height);
      }
    }
  }, [viewType, commitReview, context]);

  const checkForCommits = async () => {
    try {
      if (!context) return;

      const ap = window.AP;
      const token = await ap.context.getToken();
      const issueKey = context.jira.issue.key;
      const projectId = context.jira.project.id;
      
      console.log('Checking commits for:', { issueKey, projectId });
      
      const response = await fetch(`/get-commits?projectId=${projectId}&issueId=${issueKey}`, {
        headers: {
          'Authorization': `JWT ${token}`
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Commit check failed:', {
          status: response.status,
          error: errorData,
          projectId
        });
        throw new Error(errorData.error || 'Failed to check commits');
      }

      const data = await response.json();
      const hasCommitsFound = data.commits && data.commits.length > 0;
      setHasCommits(hasCommitsFound);
      setCommitCount(data.commits ? data.commits.length : 0);
      
      if (hasCommitsFound) {
        setViewType('review');
      }
    } catch (error) {
      console.error('Error checking for commits:', error);
      setHasCommits(false);
      setCommitCount(0);
    }
  };

  useEffect(() => {
    if (context) {
      checkForCommits();
    }
  }, [context]);

  if (!context) return <div>Loading...</div>;

  return (
    <div className="issue-panel">
      <div className="panel-nav">
        <button 
          className={`nav-button ${viewType === 'analysis' ? 'active' : ''}`}
          onClick={() => setViewType('analysis')}
        >
          Issue Analysis
        </button>
        <button 
          className={`nav-button ${viewType === 'review' ? 'active' : ''}`}
          onClick={() => setViewType('review')}
        >
          Code Review {commitCount > 0 && `(${commitCount})`}
        </button>
      </div>
      
      {viewType === 'analysis' ? (
        <MerlinAnalysis />
      ) : (
        <CommitReview 
          review={commitReview} 
          issueKey={context.jira.issue.key}
          projectId={context.jira.project.id}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
  },
  navigation: {
    display: 'flex',
    gap: '1px',
    backgroundColor: '#DFE1E6',
    padding: '1px',
    borderRadius: '3px',
    marginBottom: '20px',
  },
  activeTab: {
    padding: '8px 16px',
    backgroundColor: '#FFFFFF',
    border: 'none',
    borderRadius: '3px',
    color: '#0052CC',
    fontWeight: '500',
    cursor: 'pointer',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  inactiveTab: {
    padding: '8px 16px',
    backgroundColor: '#F4F5F7',
    border: 'none',
    borderRadius: '3px',
    color: '#42526E',
    cursor: 'pointer',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  commitCount: {
    backgroundColor: '#0052CC',
    color: '#FFFFFF',
    padding: '2px 6px',
    borderRadius: '10px',
    fontSize: '12px',
  }
};

export default IssuePanel; 